import e, { useState as I } from "react";
import { styled as b, Card as k, CardActionArea as y, CardContent as M, Box as p } from "@mui/material";
import { T as R } from "./chunk.35QuuDPq.js";
import { jsx as o } from "react/jsx-runtime";
import { createSvgIcon as r } from "@mui/material/utils";
const V = r(/* @__PURE__ */ o("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckBox"), v = r(/* @__PURE__ */ o("path", {
  d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "CheckBoxOutlineBlank"), H = r(/* @__PURE__ */ o("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonChecked"), N = r(/* @__PURE__ */ o("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonUnchecked"), T = b(k, {
  name: "SelectionCard",
  slot: "root"
})({}), U = ({
  id: a,
  title: m,
  error: x,
  disabled: u,
  checked: t,
  value: E,
  onBlur: s,
  orientation: S = "landscape",
  imgSrc: f,
  onClick: l,
  variant: c = "radio",
  ...i
}) => {
  const C = a ? `-${a}` : "", n = i["data-testid"] ? `-${i["data-testid"]}` : "", g = { checked: t, error: x, orientation: S, disabled: u }, [B, h] = I(""), $ = () => t && c === "radio" ? /* @__PURE__ */ e.createElement(H, null) : t && c === "checkbox" ? /* @__PURE__ */ e.createElement(V, null) : !t && c === "radio" ? /* @__PURE__ */ e.createElement(N, null) : /* @__PURE__ */ e.createElement(v, null);
  return /* @__PURE__ */ e.createElement(T, { variant: "outlined", ownerState: g, className: B }, /* @__PURE__ */ e.createElement(
    y,
    {
      role: c,
      id: a && `card-action${C}`,
      "data-testid": n && `card-action${n}`,
      disabled: u,
      "aria-checked": t,
      value: E,
      "aria-label": i["aria-label"],
      onBlur: (d) => {
        h(""), s == null || s(d);
      },
      onFocusVisible: () => {
        h("Mui-focusVisible");
      },
      onClick: (d) => l == null ? void 0 : l(d)
    },
    /* @__PURE__ */ e.createElement(M, null, /* @__PURE__ */ e.createElement(p, { className: "input-content" }, $(), /* @__PURE__ */ e.createElement(R, { variant: "subtitle300" }, m)), f && /* @__PURE__ */ e.createElement(
      p,
      {
        id: a && `card-image${C}`,
        "data-testid": n && `card-image${n}`,
        className: "card-image",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      /* @__PURE__ */ e.createElement("img", { src: f, alt: `${m}-image` })
    ))
  ));
};
export {
  U as S
};
